import { useSelector } from 'react-redux';
import { selectUserHasEffectiveAppAccess } from '../../selectors/selectors';
import { RootState } from '../../reducers/reducers';

const useUserBelongsToApp: (appId: string) => boolean = (appId) => {
    return useSelector((state: RootState) => selectUserHasEffectiveAppAccess(state, appId));
};

export default useUserBelongsToApp;
